import { createBigQueryEvent } from '../base';
import { USER_ACTION_PARAMS } from './constants';

export const createUserActionBigQueryEvent = (type) => createBigQueryEvent(type, USER_ACTION_PARAMS);
